import { takeEvery } from 'redux-saga/effects';

import * as homeActions from 'store/modules/home';
import { processSpecialOffer } from './utils';

export default function* listenSetSpecialOffer() {
  yield takeEvery(homeActions.setSpecialOffer.toString(), processSpecialOffer);
}
